<div
    class="rounded-xl border p-4 transition"
    [class.bg-primary-50]="!notif().read"
    [class.border-primary-soft]="!notif().read"
    [class.bg-white]="notif().read"
    [class.border-gray-100]="notif().read"
    [class.dark:bg-black/20]="notif().read"
    [class.dark:border-gray-700]="notif().read">
    <div class="flex items-start gap-3">
        <div
            class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
            [class.bg-primary-soft]="notif().type === 'confirmation'"
            [class.bg-blue-100]="notif().type === 'appointment_reminder'"
            [class.bg-purple-100]="notif().type === 'promotion'"
            [class.bg-amber-100]="notif().type === 'review'">
            <i
                class="pi text-sm"
                [class.pi-check-circle]="notif().type === 'confirmation'"
                [class.pi-clock]="notif().type === 'appointment_reminder'"
                [class.pi-tag]="notif().type === 'promotion'"
                [class.pi-star]="notif().type === 'review'"
                [class.text-primary]="notif().type === 'confirmation'"
                [class.text-blue-600]="notif().type === 'appointment_reminder'"
                [class.text-purple-600]="notif().type === 'promotion'"
                [class.text-amber-600]="notif().type === 'review'"></i>
        </div>
        <div class="min-w-0 flex-1">
            <p class="text-sm font-semibold text-gray-900 dark:text-white">
                {{ notif().title }}
            </p>
            <p class="mt-0.5 text-xs text-gray-500">
                {{ notif().message }}
            </p>
            <p class="mt-1 text-[11px] text-gray-400">
                {{ notif().createdAt | date: 'MMM d, h:mm a' }}
            </p>
        </div>
        @if (!notif().read) {
            <span
                class="bg-primary mt-1.5 h-2 w-2 shrink-0 rounded-full"></span>
        }
    </div>
</div>
